module.exports = __webpack_public_path__ + "static/media/uncheckMark.f7e49c5a.svg";